import script from "./AnotherPaymentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AnotherPaymentDialog.vue?vue&type=script&setup=true&lang=js"

import "./AnotherPaymentDialog.vue?vue&type=style&index=0&id=d87816a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d87816a0"]])

export default __exports__